import {
    PAN_CARD, POLICE_FIR, EXTERNAL_DAMAGE, INTERNAL_DAMAGE, RC_BOOK, AADHAR_CARD, CNG, DRIVING_LICENSE,
    VIDEO_TITLE, SELFI_IMAGE, ODOMETER, VIDEO_URL, PRIVATE_CAR_20103, PRIVATE_CAR_20102, PRIVATE_CAR_20101,
    BIKE_20202, BIKE_20201, CUMMERCIAL_20302, CUMMERCIAL_20301
} from './common/Constants'
import Orientation from 'react-native-orientation';
import {
    View, Text, StyleSheet, ScrollView, TouchableOpacity, TextInput,
    StatusBar, FlatList, Alert, PermissionsAndroid, ToastAndroid, Platform,
    Dimensions, ActivityIndicator, BackHandler
} from 'react-native';
import React, { Component } from 'react';
import { Image } from 'react-native';
import Colors from './common/Colors'
import { RNCamera } from 'react-native-camera';
import Icon from 'react-native-vector-icons/FontAwesome';
import moment from 'react-moment'
import Geolocation from '@react-native-community/geolocation';
import VideoPlayer from 'react-native-video-player'
import { INSTRUCTIONS_URL, SELFSURVEYSERVICE_DOCUMENT_URL, AGENT_DATA } from './Api/ApiUrls'
import RNFetchBlob from 'rn-fetch-blob'
import ViewShot from "react-native-view-shot";
import axios from 'axios'
import Upload from 'react-native-background-upload'
// import documentUploadData from './src/common/DocumentCollection'
import DeviceInfo from 'react-native-device-info';
import * as Progress from 'react-native-progress';
import status from './common/Status';
import {
    HideNavigationBar,
    ShowNavigationBar,
} from 'react-native-navigation-bar-color';
import PropTypes from 'prop-types';
import Marker from "react-native-image-marker"

// const IMEI = require('react-native-imei');
const initial = Orientation.getInitialOrientation();
let SCREEN_WIDTH;
let SCREEN_HEIGHT;
if (initial === 'PORTRAIT') {
    SCREEN_HEIGHT = Math.round(Dimensions.get('window').width - 40)
    SCREEN_WIDTH = Math.round(Dimensions.get('window').height)
} else {
    SCREEN_HEIGHT = Math.round(Dimensions.get('window').height)
    SCREEN_WIDTH = Math.round(Dimensions.get('window').width)
}
const crossMark = require('./common/Image/crossMark.png')
const tickMark = require('./common/Image/tickMark.png')
const car = require('./common/Image/car.png')
const Auto = require('./common/Image/Auto.png')
const Bike = require('./common/Image/Bike.png')

let dynammicactivityId = ''
export default class PI extends Component {


    static navigationOptions = {
        //To hide the NavigationBar from current Screen
        headerShown: false
    };
    constructor(props) {
        super(props);
        this.state = ({
            isDisplayQuoteInstruction: true,
            isWithQuote: true,
            isWithOutQuote: false,
            isDisplayInstruction: false,
            torchon: '',
            isDisplayCameraPreview: false,
            isDisplayCamera: false,
            localPath: '',
            flashState: true,//for flash
            dateAndTime: '',//date and time
            currentLongitude: 'unknown',//Initial Longitude
            currentLatitude: 'unknown',//Initial Latitude
            isDisplayVideoRecorder: false,
            instructionData: '',
            fullDataSource: '',
            assets: '',
            headerShown: false,
            count: 0,
            dataSource: '',
            cameraState: '',
            buttonText: '',
            skipdata: '',
            isBackButtonPressed: false,
            isSkipButtonPressed: false,
            extention: '',
            screenShotPath: '',
            isDisplayUploadDocument: false,
            upLoadIamgeDataSource: [],
            documentUploadPercentage: 0,
            odometerReading: '',
            ANDROID_ID: '',
            CurrentDate: '',
            showError: false,
            quoteNumber: '',
            showQuoteError: false,
            isLoading: true,
            registrationNumber: '',
            isSelected: false,
            isFocused: false

        })

    }

    componentDidMount() {
        this.handleBackButton()
    }

    handleBackButton() {
        if (Platform.OS === 'android') {
            this.backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
                if (this.props !== undefined && this.props.screenProps !== undefined &&
                    this.props.screenProps.props !== undefined &&
                    this.props.screenProps.props.props !== undefined) {
                    this.props.screenProps.props.props.navigation.pop()
                }
                return true;
            });
        }
    }

    captureButton() {
        //condition for Skip Documents
        if (this.state.skipdata == PAN_CARD || this.state.skipdata == AADHAR_CARD || this.state.skipdata == CNG ||
            this.state.skipdata == POLICE_FIR || this.state.skipdata == EXTERNAL_DAMAGE || this.state.skipdata == INTERNAL_DAMAGE ||
            this.state.skipdata == DRIVING_LICENSE) {
            return (
                <View style={{ flex: 1, flexDirection: 'row' }}>
                    <View style={{ flex: 0.45 }}>
                        <TouchableOpacity onPress={() => [this.setState({ isDisplayInstruction: false })]}>
                            <View style={styles.captureImageButtonView}>
                                <Text style={styles.captureImageButtonText}>Capture</Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={{ flex: 0.1 }}></View>
                    <View style={{ flex: 0.45 }}>
                        <TouchableOpacity onPress={() => [this.setState({ isSkipButtonPressed: true }), this.increseCount()]}>
                            <View style={styles.captureImageButtonView}>
                                <Text style={styles.captureImageButtonText}>Skip</Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                </View>
            )
        } else if (this.state.rcbFront == 'RCB2') {
            return (
                <View style={{ flex: 1, flexDirection: 'row' }}>
                    <View style={{ flex: 0.45 }}>
                        <TouchableOpacity onPress={() => [this.setState({ isDisplayInstruction: false, count: this.state.count - 1 })]}>
                            <View style={styles.captureImageButtonView}>
                                <Text style={{
                                    fontSize: 14,
                                    fontFamily: 'Muli-Black',
                                    alignSelf: 'center'
                                }}>Capture More</Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={{ flex: 0.1 }}></View>
                    <View style={{ flex: 0.45 }}>
                        <TouchableOpacity onPress={() => [this.setState({ isSkipButtonPressed: true }), this.increseCount()]}>
                            <View style={styles.captureImageButtonView}>
                                <Text style={styles.captureImageButtonText}>Skip</Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                </View>
            )
        } else {
            return (
                <TouchableOpacity onPress={() => this.validate()}>
                    <View style={styles.captureImageButtonView}>
                        <Text style={styles.captureImageButtonText}>{this.state.buttonText}</Text>
                    </View>
                </TouchableOpacity>
            )
        }



    }
    validate() {
        if (this.state.skipdata == ODOMETER) {
            if (this.state.odometerReading != '') {
                this.setState({ isDisplayInstruction: false, showError: false, odometerReading: '' })
            } else {
                this.setState({ isDisplayInstruction: true, showError: true })

            }
        } else {
            this.setState({ isDisplayInstruction: false })
        }

        if (this.state.registrationNumber.length > 0 && this.state.isSelected == true && this.state.isDisplayInstruction == false) {
            this.setState({ isDisplayInstruction: true, isWithOutQuote: false })
        }
    }

    validateQuote() {
        if (this.state.quoteNumber === '') {
            this.setState({ showQuoteError: true })
            return false;
        } else {
            this.setState({ showQuoteError: false })
            return true
        }
    }

    /*
    **************************************************************************************************************
    */
    componentWillUnmount() {
        Geolocation.clearWatch(this.watchID);//For GeoLocation
        if (Platform.OS === 'android') {
            this.backHandler.remove();
        }
    }
    /*
    **************************************************************************************************************
    */

    /*
                               %%%%%%%%%%%%% For Take Picture %%%%%%%%%%%%%%%%
    */
    takePicture = async function (camera) {
        const options = { quality: 0.2, base64: true };
        const data = await camera.takePictureAsync(options);
        //  eslint-disable-next-line
        this.setState({
            localPath: data.uri,
            cameraData: data,
            isDisplayCameraPreview: true,
            isDisplayCamera: false
        })//path of photo

        // console.log(data);//path of photo


        this.watermarkLocation()
        //Date calulation for the display on preciew Screen
        const date = new Date().getDate();
        const month = new Date().getMonth() + 1;
        const year = new Date().getFullYear();

        //Time calulation for the display on preciew Screen
        const hour = new Date().getHours();
        const minute = new Date().getMinutes();
        const seconds = new Date().getSeconds();
        //Alert.alert(date + '-' + month + '-' + year);
        // You can turn it in to your desired format
        this.setState({ dateAndTime: date + '-' + month + '-' + year + "  " + hour + ':' + minute + ':' + seconds })//format: dd-mm-yyyy;

    }
    watermarkLocation() {
        return (
            Marker.markText({
                src: this.state.localPath,
                text: 'lat: ' + this.state.currentLatitude + " " + "long: " + this.state.currentLongitude,
                position: 'topLeft',
                fontName: 'Muli-Regular',
                fontSize: 30,
                scale: 1,
                quality: 100,
                color: Colors.digitYellow,

            }).then((res) => {
                this.setState({
                    markLocationResult: 'file://' + res
                })
                console.log("the path is" + this.state.markLocationResult)
                this.watermarkDigitEdge()


            }).catch((err) => {
                console.log(err)
                this.setState({
                    err
                })
            })

            // <Image
            //     source={this.state.ress}
            //     style={{ width: 500, height: 500, backgroundColor: 'blue' }}
            // />
        );
    }

    watermarkDigitEdge() {
        return (
            Marker.markText({
                src: this.state.markLocationResult,
                text: 'Digit Edge',
                position: 'topRight',
                fontName: 'Muli-Regular',
                fontSize: 30,
                scale: 1,
                quality: 100,
                color: Colors.digitYellow,

            }).then((res) => {
                this.setState({
                    markDigitEdgeResult: 'file://' + res,
                })
                console.log("the path is" + this.state.markDigitEdgeResult)

                this.finalWatermark()
            }).catch((err) => {
                console.log(err)
                this.setState({
                    err
                })
            })

        );
    }

    finalWatermark() {
        return (
            Marker.markText({
                src: this.state.markDigitEdgeResult,
                text: this.state.dateAndTime,
                position: 'bottomLeft',
                fontName: 'Muli-Regular',
                fontSize: 30,
                scale: 1,
                quality: 30,
                color: Colors.digitYellow,

            }).then((res) => {
                this.setState({
                    finalWatermarkResult: 'file://' + res,
                    // isLoading: false

                })
                console.log("the path is" + this.state.finalWatermarkResult)
            }).catch((err) => {
                console.log(err)
                this.setState({
                    err
                })
            })

        );
    }
    /*
**************************************************************************************************************
*/


    /*
                                 %%%%%%%%%%%%% For Video Record %%%%%%%%%%%%%%%%
      */

    async startRecording() {
        this.setState({ recording: true });
        // default to mp4 for android as codec is not set
        const options = { quality: 0.2, base64: true };
        const { uri, codec = "mp4" } = await this.camera.recordAsync(options);
        this.setState({ localPath: uri })
        console.log(this.state.localPath)


    }

    //Stop Recording
    stopRecording() {
        this.camera.stopRecording();
        this.setState({ isDisplayVideoPlayer: true, isDisplayVideoRecorder: false })
        this.setState({ recording: false });
    }



    /*
******************************** for creating  floder at local storage*************************************
    */
    async createFloder(activityId, activityTypeId) {


        console.log(this.state.count)

        const POSP = RNFetchBlob.fs.dirs.SDCardDir + '/POSP/';//Create Floder in External storage
        this.setState({ FilePath: POSP })
        let exists = await RNFetchBlob.fs.exists(POSP) // checkExist 
        if (exists) {
            let isDir = await RNFetchBlob.fs.isDir(POSP);
            if (isDir) {
                // Permission for storage
                const granted = await PermissionsAndroid.request(
                    PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE,
                    {
                        title: 'Read Internal Storage',
                        message: 'Read Internal Storage',
                        buttonPositive: 'Ok',
                        buttonNegative: 'Cancle'
                    }
                )
                if (granted) {
                    // if Granted
                    const Image_Name = activityId + this.state.instructionData[this.state.count - 1].imageName + this.state.extention //Image NAme with Extension
                    this.setState({ imageName: Image_Name })
                    console.log(this.state.imageName)
                    await RNFetchBlob.fs.writeFile(POSP + Image_Name, 'base64');
                    // let _copy = await RNFetchBlob.fs.cp(this.state.screenShotPath, POSP + Image_Name);
                    let _copy = await RNFetchBlob.fs.cp(this.state.finalWatermarkResult, POSP + Image_Name);

                    RNFetchBlob.fs.stat(this.state.FilePath + this.state.imageName)
                        .then((stats) => {
                            console.log("FileName: " + stats.filename)
                            console.log("FileSize: " + stats.size)
                            console.log("type: " + stats.type)
                            console.log("lastModified: " + stats.lastModified)
                            this.setState({ fileSize: stats.size })
                        })
                        .catch((err) => {

                        })
                    this.uploadImage(activityId, activityTypeId)

                } else {
                    // ask Permission
                    this.createFloder()
                }
            }
        } else {
            //IF not then create floder
            RNFetchBlob.fs
                .mkdir(POSP)
                .catch(err => {
                    console.log(err);
                });
            this.createFloder()
        }

    }


    /*
    **************************************************************************************************************
    */


    // For Flash
    toggleTorch() {
        if (this.state.flashState == true) {
            console.log('AUTO')
            this.setState({ flashState: false })
        } else {
            this.setState({ flashState: true })
            console.log('ON')


        }
    }

    /*
    **************************************************************************************************************
    */


    flatListOrNot() {
        if (this.state.skipdata != ODOMETER) {
            return (
                <View style={styles.infoScrollView}>
                    <ScrollView>
                        <FlatList
                            data={this.state.dataSource}
                            renderItem={this.renderItem}
                            style={{ fontFamily: 'Mulli-Regular', }}
                        />
                    </ScrollView>
                </View>
            )
        } else {
            return (
                <View>
                    <View style={styles.infoScrollViewWithTextInput}>
                        <ScrollView>
                            <FlatList
                                data={this.state.dataSource}
                                renderItem={this.renderItem}
                            />
                        </ScrollView>
                    </View>
                    <Text style={styles.odometerText}>Odometer Reading:</Text>
                    <TextInput
                        style={styles.odometerInputText}
                        keyboardType='numeric'
                        onChangeText={odometerReading => this.setState({ odometerReading })}
                    />
                    {this.showErrorText()}

                </View>
            )
        }
    }
    showErrorText() {
        if (this.state.showError) {
            return (
                <Text style={{ color: 'red', marginLeft: 4, fontFamily: 'Muli-Regular' }}>Enter Odometer Reading</Text>
            )
        }

    }

    showQuoteErrorText() {
        return (
            <Text style={{ color: 'red', marginLeft: 16, fontFamily: 'Muli-Regular' }}>Enter quote number</Text>
        )
    }


    /*
    **************************************************************************************************************
    */


    //Display Data in FlatList
    renderItem = ({ item }) => (
        <Text style={styles.instructionText}>{'\u2B24'} {item.instructionData}</Text>
    )

    /*
     **************************************************************************************************************
*/
    uploadedDocumentStatus = ({ item }) => (
        <View>
            <View style={{ margin: 16, width: SCREEN_HEIGHT, height: SCREEN_WIDTH / 8.5, flexDirection: 'row' }}>
                <View style={{ flex: 0.2 }}>
                    {this.uploadedDocumentImageOrVideo(item)}
                </View>
                <View style={{ flex: 0.03, justifyContent: 'center' }}>

                </View>
                <View style={{ flex: 0.77, }}>
                    <View style={{ flex: 0.45, justifyContent: 'center' }}>
                        <Text>{item.stepTitle}</Text>
                    </View>
                    <View style={{ flex: 0.15, justifyContent: 'center' }}>
                        <Text>{(item.imageSize / 1024).toString().split('.')[0]} KB</Text>
                    </View>
                    <View style={{ flex: 0.15, justifyContent: 'center' }}>
                        <Progress.Bar progress={item.upLoadStatus} width={SCREEN_HEIGHT / 1.5} color={Colors.digitYellow} height={2} borderColor={'white'} />
                    </View>
                    <View style={{ flex: 0.25, justifyContent: 'center' }}>
                        <Text style={{ color: Colors.digitYellow }}>{item.upLoadStatus * 100} % Completed</Text>
                    </View>

                </View>

            </View>
            <View style={{ borderRadius: 1, width: SCREEN_WIDTH, height: 1, borderWidth: 0.5, color: Colors.borderBlack }}></View>

        </View>
    )
    //Checking the document image or Video
    uploadedDocumentImageOrVideo(item) {
        const type = item.imagePath.split('.')
        if (type[3] == 'mp4') {
            return (
                <VideoPlayer
                    video={{ uri: item.imagePath }}
                    pauseOnPress={true}
                    autoplay={true}
                    disableSeek={true}
                    style={{ flex: 1 }}


                >
                </VideoPlayer>
            )

        } else {
            return (
                <Image
                    source={{ uri: item.imagePath }}
                    resizeMethod='auto'
                    resizeMode='contain'
                    style={{ flex: 1, resizeMode: 'contain' }}

                />
            )
        }

    }
    //Display image or video
    imageOrVideo() {

        if (this.state.assets == VIDEO_URL && this.state.isDisplayVideoRecorder == true) {
            return (
                <VideoPlayer
                    video={{ uri: "https://d2h44aw7l5xdvz.cloudfront.net/videos/self-inspection-for-car.mp4" }}
                    videoHeight={SCREEN_HEIGHT}
                    videoWidth={SCREEN_WIDTH}
                    pauseOnPress={true}
                    autoplay={true}
                    disableSeek={true}
                    style={{ flex: 1 }}

                >
                </VideoPlayer>
            )

        } else {
            return (
                <Image
                    source={{ uri: this.state.assets }}
                    style={styles.productImageStyle}
                    resizeMethod='auto'
                    resizeMode='contain'
                />
            )
        }
    }

    /*
**************************************************************************************************************
*/

    //reduce the count
    reduceCount() {
        if (this.state.count >= 1) {
            this.setState({
                count: this.state.count - 1
            })
        }
        setInterval(() => {
            if (this.state.isBackButtonPressed == true) {
                this.renderDataToScreen()
            }
            this.setState({ isBackButtonPressed: false })
        }, 100);

    }

    /*
    **************************************************************************************************************
*/
    //increase the count
    increseCount() {

        if (this.state.count <= this.state.instructionData.length) {
            this.setState({
                count: this.state.count + 1
            })
        }
        setInterval(() => {
            if (this.state.isSkipButtonPressed == true) {
                this.renderDataToScreen()
            }
            this.setState({ isSkipButtonPressed: false })
        }, 100);
    }

    /*
      **************************************************************************************************************
      */

    //Load after screen shot 
    // onImageLoad = () => {
    //     this.setState({ isImageLoad: true })
    //     setInterval(() => {
    //         if (this.state.isImageLoad == true) {

    //             this.refs.viewShot.capture().then(uri => {
    //                 this.setState({ screenShotPath: uri })
    //                 console.log("do something with ", this.state.screenShotPath);

    //             })

    //         }
    //         this.setState({ isImageLoad: false })
    //     }, 300);
    // };

    /*
    **************************************************************************************************************
    */

    //upload images
    uploadImage(activityId) {
        const documentUploadData = {

            "activityId": activityId,
            "documentSource": "DigitEdge",
            "geoLocation": {
                "deviceIMEI": this.state.ANDROID_ID,
                "deviceName": this.state.DEVICE_NAME,
                "deviceTime": this.state.CurrentDate,
                "documentSource": "DigitEdge",
                "ipAddress": this.state.IP,
                "isBlocked": false,
                "latitude": this.state.currentLatitude,
                "longitude": this.state.currentLongitude,
                "macAddress": this.state.MAC,
                "operatingSystem": this.state.VERSION,
                "timezone": "Asia/Kolkata"
            },
            "isLast": false,
            "isLastData": false,
            "isLastDocument": false,
            "isSurveyor": false,
            "manualOdometerReading": "",
            "source": "DIGITEDGE"
        }

        RNFetchBlob.fetch('POST', SELFSURVEYSERVICE_DOCUMENT_URL, {
            'Content-Type': 'multipart/form-data',
        }, [
            // element with property `filename` will be transformed into `file` in form data
            //file name is Original file name
            { name: 'file', filename: this.state.imageName, type: 'image/jpg', data: this.state.FilePath + this.state.imageName },
            { name: 'documentData', data: JSON.stringify(documentUploadData) },
        ])
            .uploadProgress({ interval: 250 }, (written, total) => {
                console.log('Written', written)
                console.log('total', total)
                console.log('uploaded', written / total)
                this.setState({ documentUploadPercentage: (written / total) })


            })
            // listen to download progress event, every 10%
            .progress({ count: 10 }, (received, total) => {
                console.log('progress', received / total)
                // let isExisist = this.state.upLoadIamgeDataSource.find(this.state.upLoadIamgeDataSource.stepTitle == this.state.instructionData[this.state.count - 1].stepTitle)

                this.state.upLoadIamgeDataSource.push({

                    imagePath: 'file://' + this.state.FilePath + this.state.imageName,
                    stepTitle: this.state.instructionData[this.state.count - 1].stepTitle,
                    imageSize: this.state.fileSize,
                    upLoadStatus: this.state.documentUploadPercentage,

                });

                if (this.state.count == this.state.instructionData.length) {
                    // if (this.state.count == 3) {
                    console.log(this.state.count)
                    this.props.navigation.navigate("DocumentUpload")
                }

                console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!" + this.state.upLoadIamgeDataSource.length)
            })

            .then((response) => {
                console.log("******************** resp: " + JSON.stringify(response))
            }).catch((err) => {
                console.log("******************** err: " + JSON.stringify(err))
            })
        this.renderDataToScreen()

    }

    render() {
        const {
            activityId,
            activityTypeId
        } = this.props.screenProps;
        //************************** Insruction Screen*************************************** */
        { console.log("activityId from user" + activityId) }
        // { console.log("activityTypeId from user" + activityTypeId) }

        //Activity ID
        dynammicactivityId = activityTypeId

        // frist page 

        if (this.state.isWithQuote == true) {
            return (
                <View style={{ flex: 1, backgroundColor: '#FFFFFF' }}>
                    <StatusBar
                        hidden={true}
                    />
                    <View style={{ flex: 0.9 }}>
                        <View style={{ width: SCREEN_WIDTH, height: 70, backgroundColor: '#F5F5F5', justifyContent: 'center', marginBottom: 16 }}>
                            <Text style={{ fontFamily: 'Muli-Bold', fontSize: 20, marginLeft: 16 }}>Pre Inspection</Text>
                        </View>
                        <View>
                            <Text style={{ marginLeft: 16, fontSize: 16, fontFamily: 'Muli-Bold', marginBottom: 4 }}>Quote/Policy Number</Text>
                            <TextInput
                                style={{ borderColor: 'black', borderWidth: 1, marginLeft: 16, borderRadius: 4, fontFamily: 'Muli-Regular', fontSize: 16, }}
                                placeholder={"Quote Number"}
                                keyboardType='default'
                                onChangeText={quoteNumber => this.setState({ quoteNumber })} />

                            {this.state.showQuoteError && this.showQuoteErrorText()}
                        </View>


                        <View style={{ marginTop: 22 }}>
                            <TouchableOpacity onPress={() => this.props.navigation.navigate("WithOutQuote")}>
                                <Text style={{ marginLeft: 16, fontSize: 16, fontFamily: 'Muli-Bold', color: Colors.digitYellow }}>Don't have Quote Number</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View style={{ flex: 0.1, justifyContent: 'flex-start' }}>

                        <View style={{ marginLeft: 16 }}>
                            {/* <TouchableOpacity onPress={() => this.setState({ isDisplayQuoteInstruction: true, isWithQuote: false })}> */}
                            <TouchableOpacity onPress={() => { this.validateQuote() && this.props.navigation.navigate("QuoteInstructions") }}>
                                <View style={styles.captureImageButtonView}>
                                    <Text style={styles.captureImageButtonText}>Continue</Text>
                                </View>
                            </TouchableOpacity>
                        </View>

                    </View>
                </View>
            )
        }
        // if (this.state.isDisplayVideoRecorder == true) {
        //     const { recording, processing } = this.state;

        //     let button = (
        //         <View style={{ flex: 1, position: 'absolute', width: SCREEN_WIDTH, height: SCREEN_HEIGHT }}>
        //             <View style={{ flex: 0.5, justifyContent: 'flex-end' }}>
        //                 <TouchableOpacity onPress={() => [this.startRecording()]} style={styles.capture}>
        //                     {/* <Text style={{ fontSize: 14 }}> SNAP </Text> */}
        //                     <Icon
        //                         name="video-camera"
        //                     />
        //                 </TouchableOpacity>
        //             </View>

        //         </View>
        //     );

        //     if (recording) {
        //         button = (
        //             <View style={{ flex: 1, position: 'absolute', width: SCREEN_WIDTH, height: SCREEN_HEIGHT }}>
        //                 <View style={{ flex: 0.5, justifyContent: 'flex-end' }}>
        //                     <TouchableOpacity onPress={() => [this.stopRecording()]} style={styles.capture}>
        //                         {/* <Text style={{ fontSize: 14 }}> SNAP </Text> */}
        //                         <Icon
        //                             name="video-off-outline"
        //                         />
        //                     </TouchableOpacity>
        //                 </View>

        //             </View>
        //         );
        //     }
        //     return (
        //         <View style={styles.container}>
        //             <StatusBar
        //                 hidden={true}
        //             />
        //             <RNCamera
        //                 ref={ref => {
        //                     this.camera = ref;
        //                 }}
        //                 style={styles.preview}
        //                 type={RNCamera.Constants.Type.back}
        //                 flashMode={RNCamera.Constants.FlashMode.on}
        //                 permissionDialogTitle={"Permission to use camera"}
        //                 permissionDialogMessage={
        //                     "We need your permission to use your camera phone"
        //                 }
        //             >

        //                 {({ camera, status, recordAudioPermissionStatus }) => {
        //                     // if (status !== 'READY') return <PendingView />;
        //                     return (

        //                         <View style={{ flex: 1, position: 'absolute', width: SCREEN_WIDTH, height: SCREEN_HEIGHT }}>
        //                             <Image
        //                                 source={crossMark}
        //                                 style={{ width: 50, height: 50, position: 'absolute', left: 1, }}
        //                             />
        //                             <Image
        //                                 source={crossMark}
        //                                 style={{ width: 50, height: 50, position: 'absolute', left: 1, bottom: 1, }}
        //                             />
        //                             <Image
        //                                 source={crossMark}
        //                                 style={{ width: 50, height: 50, position: 'absolute', right: 1, bottom: 1, }}
        //                             />
        //                             <Image
        //                                 source={crossMark}
        //                                 style={{ width: 50, height: 50, position: 'absolute', right: 1 }}
        //                             />
        //                             {button}

        //                         </View>
        //                     );

        //                 }}
        //             </RNCamera>

        //         </View>
        //     );
        // }
        // //             //**************************Video Player*************************************** */

        // if (this.state.isDisplayVideoPlayer == true) {

        //     return (

        //         <View>
        //             <StatusBar
        //                 hidden={true}
        //             />

        //             <VideoPlayer
        //                 video={{ uri: this.state.localPath }}
        //                 videoWidth={SCREEN_WIDTH}
        //                 videoHeight={SCREEN_HEIGHT}
        //                 pauseOnPress={true}
        //                 seekBarWidth={5}
        //             >
        //             </VideoPlayer>
        //             {/* Buttons on video player */}
        //             <View style={{ position: 'absolute', left: 10, bottom: 50 }}>
        //                 <TouchableOpacity onPress={() => this.setState({ isDisplayVideoRecorder: true })}>
        //                     <Text style={{ backgroundColor: Colors.digitYellow, paddingTop: 3, paddingBottom: 3, paddingLeft: 6, paddingRight: 6, borderRadius: 4 }}>RETRY</Text>
        //                 </TouchableOpacity>
        //             </View>
        //             {/* Buttons on video player */}

        //             <View style={{ position: 'absolute', right: 10, bottom: 50 }}>
        //                 <TouchableOpacity onPress={() => [this.setState({ isDisplayVideoPlayer: false, isDisplayInstruction: true, isDisplayVideoRecorder: false, count: this.state.count + 1 }), this.createFloder(activityId, activityTypeId)]}>
        //                     <Text style={{ backgroundColor: Colors.digitYellow, paddingTop: 3, paddingBottom: 3, paddingLeft: 6, paddingRight: 6, borderRadius: 4 }}>SUBMIT</Text>
        //                 </TouchableOpacity>
        //             </View>

        //         </View>
        //     )
        // }

        // //////////////////////////////////////////////////////////////////////////////
        // if (this.state.isDisplayUploadDocument == true) {
        //     return (

        //         <View>
        //             <StatusBar
        //                 hidden={true}
        //             />
        //             <View style={styles.documentProcessView}>
        //                 <Text style={styles.documentProcessHeader}>Document being processd!</Text>
        //             </View>
        //             <View style={{ width: SCREEN_WIDTH, height: SCREEN_WIDTH }}>
        //                 <FlatList
        //                     data={this.state.upLoadIamgeDataSource}
        //                     keyExtractor={(item, index) => item.index}
        //                     renderItem={this.uploadedDocumentStatus}
        //                     maxToRenderPerBatch={100}
        //                     updateCellsBatchingPeriod={1000}
        //                     style={{
        //                         backgroundColor: 'white', marginBottom: 40, fontFamily: 'Mulli-Regular',
        //                     }}
        //                 />
        //             </View>


        //         </View>



        //     )
        // }
    }
}

PI.propTypes = {
    activityId: PropTypes.string,
    activityTypeId: PropTypes.string,
};

PI.defaultProps = {
    activityId: '-1',
    activityTypeId: '-1',

};
const styles = StyleSheet.create({
    main: {
        flex: 1,
        flexDirection: 'row',
        backgroundColor: '#FFFFFF'
    },
    productImageView: {
        flex: 0.475,
    },
    blankView: {
        flex: 0.05,
    },
    productInfoView: {
        flex: 0.475,
        width: SCREEN_WIDTH,
        height: SCREEN_HEIGHT
    },
    headerView: {
        backgroundColor: '#F5F5F5',
        height: 60,
        justifyContent: 'center'
    },
    headerText: {
        marginLeft: 16,
        fontSize: 16,
        fontFamily: 'Muli-Black',
        marginRight: 16
    },
    documentProcessHeader: {
        marginLeft: 16,
        fontSize: 26,
        fontFamily: 'Muli-Black',
        marginRight: 16,
        justifyContent: 'center'
    },
    documentProcessView: {
        width: SCREEN_WIDTH,
        height: 60,
        justifyContent: 'center',
        backgroundColor: '#F5F5F5'
    },
    productImageStyle: {
        marginTop: 8,
        marginLeft: 16,
        marginBottom: 40,
        height: SCREEN_HEIGHT - 70,

    },
    backButtonImageStyle: {
        marginLeft: 32,
        height: 30,
        width: 40,
        backgroundColor: 'red'
    },
    subHeaderText: {
        fontFamily: 'Mulli-Regular',
        fontSize: 16,
        marginLeft: 16,
        marginRight: 16

    },
    instructionText: {
        fontFamily: 'Mulli-Regular',
        fontSize: 16,
        marginLeft: 32,
        marginBottom: 20,
        marginRight: 16

    },
    captureImageButtonView: {
        height: 48,
        borderRadius: 4,
        backgroundColor: Colors.digitYellow,
        marginTop: 2,
        flexDirection: 'row',
        justifyContent: 'center',
        marginRight: 16

    },
    captureImageButtonText: {
        fontSize: 16,
        fontFamily: 'Muli-Black',
        alignSelf: 'center'
    },
    container: {
        flex: 1,
        // flexDirection: 'row',
        // backgroundColor: 'black',
    },
    preview: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    capture: {
        flex: 0,
        backgroundColor: '#fff',
        borderRadius: 5,
        padding: 15,
        paddingHorizontal: 20,
        alignSelf: 'flex-end',
        margin: 20,
        position: 'absolute'
    },
    flash: {
        flex: 0,
        backgroundColor: '#fff',
        borderRadius: 5,
        padding: 15,
        paddingHorizontal: 20,
        alignSelf: 'flex-end',
        margin: 20,
        position: 'absolute'
    },
    previewImageStyle: {
        width: SCREEN_WIDTH,
        height: SCREEN_HEIGHT,
        resizeMode: 'contain'
    },
    dateAndTimeText: {
        position: 'absolute',
        fontSize: 20,
        color: Colors.digitYellow,
        left: 1,
        bottom: 1
    },
    previewImageIconMainView: {
        flex: 0.05,
        backgroundColor: 'black'
    },
    tickMarkImageView: {
        flex: 0.6,
        justifyContent: 'flex-end'
    },
    tickMarkImageStyle: {
        width: 30,
        height: 30,
        backgroundColor: 'white',
        alignSelf: 'center',
        marginBottom: 20
    },
    crossImageView: {
        flex: 0.4,
        justifyContent: 'flex-end',
        marginBottom: 20
    },
    crossImageStyle: {
        width: 30,
        height: 30,
        backgroundColor: 'white',
        alignSelf: 'center',
    },
    cameraIconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        width: SCREEN_WIDTH,
        position: 'absolute'
    },
    infoScrollView: {
        marginTop: 40,
        height: SCREEN_HEIGHT - 220
    },
    subHeaderTextView: {
        height: 40,
        marginTop: 8
    },
    backButtonImageView: {
        backgroundColor: '#F5F5F5',
        height: 60,
        justifyContent: 'center',
    },
    latLongText: {
        position: 'absolute',
        fontSize: 20,
        color: Colors.digitYellow,
        left: 1,
    },
    digitEdgeText: {
        position: 'absolute',
        fontSize: 20,
        color: Colors.digitYellow,
        right: 1,
    },
    odometerText: {
        fontSize: 16,
        fontFamily: 'Muli-Black',
        marginLeft: 16,
    },
    odometerInputText: {
        fontSize: 16,
        fontFamily: 'Muli-Black',
        borderRadius: 4,
        borderColor: Colors.digitYellow,
        borderWidth: 1,
        marginTop: 5,
        marginRight: 16,
        marginBottom: 5
    },
    infoScrollViewWithTextInput: {
        height: SCREEN_HEIGHT - 270
    },
    // productImageView: {
    //     flexDirection: 'row',
    //     justifyContent: 'center'
    // },
    // productImage: {
    //     width: 50,
    //     height: 50,
    //     marginTop: 16,
    //     flexDirection: 'row',
    //     justifyContent: 'space-around',
    //     marginLeft: 16,
    //     marginRight: 16
    // },
});
